import { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import aixconceptLogo from '../assets/aixconcept-logo-inverse.svg';
import mnsproLogo from '../assets/mnspro-cloud-logo.svg';
import './PageLayout.scss';

/**
 * Full-screen layout with the dark MNSpro brand background, AixConcept logo
 * top-left as a permanent watermark and the MNSpro Cloud logo above the
 * centered content card.
 */
export const PageLayout = ({ children }: PropsWithChildren) => (
  <Box className="page-layout">
    <img src={aixconceptLogo} alt="AixConcept" className="page-layout__brand-mark" />
    <Box className="page-layout__content">
      <Box className="page-layout__card">
        <img src={mnsproLogo} alt="MNSpro Cloud" className="page-layout__product-logo" />
        {children}
      </Box>
    </Box>
  </Box>
);
